// extracted by mini-css-extract-plugin
export default {"notification":"abtasty-qa-assistant__EventNotification-module__notification___jlGvZ"};